const decodeULEB128 = (byteStream: Uint8Array, index: number) => {
  let result = 0;
  let shift = 0;

  while (index < byteStream.length) {
    const byte = byteStream[index];
    result |= (byte & 0x7f) << shift;
    shift += 7;
    index += 1;

    if ((byte & 0x80) === 0) {
      break;
    }
  }

  return [result, index];
};

const readUint64LE = (buffer: Uint8Array, offset: number) => {
  const low =
    buffer[offset] +
    (buffer[offset + 1] << 8) +
    (buffer[offset + 2] << 16) +
    (buffer[offset + 3] << 24);

  const high =
    buffer[offset + 4] +
    (buffer[offset + 5] << 8) +
    (buffer[offset + 6] << 16) +
    (buffer[offset + 7] << 24);

  // Assuming the timestamp won't exceed the JavaScript safe integer limit (2^53 - 1)
  return low + 0x100000000 * high;
};

export const TimeDecompressionServiceImplFactory = () => {
  const convertRLETimestampByteStream = (byteStream: Uint8Array) => {
    const items = [];
    let index = 8;
    const timestampStart = readUint64LE(byteStream, 0);
    items.push(timestampStart);

    while (index < byteStream.length) {
      const [value, newIndex] = decodeULEB128(byteStream, index);
      items.push(value);
      index = newIndex;
    }

    return items;
  };

  const reconstructTimestampsFromRLEByteStream = (byteStream: Uint8Array) => {
    const encodedTimestampList = convertRLETimestampByteStream(byteStream);
    const startIdx = encodedTimestampList[0];
    const rowsDeltaList = encodedTimestampList.slice(1);

    const timestampIdxs: number[] = [];
    timestampIdxs.push(startIdx);

    const rowsNrList: number[] = [];
    const deltaList: number[] = [];

    rowsDeltaList.map((rowDeltaItem, i) => {
      if (i % 2 === 0) return rowsNrList.push(rowDeltaItem);
      return deltaList.push(rowDeltaItem);
    });

    let timestampTemp = startIdx;
    for (let i = 0; i < rowsNrList.length; i++) {
      const rowsNr = rowsNrList[i];
      const delta = deltaList[i];
      for (let j = 1; j <= rowsNr; j++) {
        const timestampNext = timestampTemp + j * delta * 1000000000;
        timestampIdxs.push(timestampNext);
      }
      timestampTemp = timestampIdxs.at(-1)!!;
    }

    return timestampIdxs;
  };

  // Note: JavaScript does not have a direct equivalent of Pandas DatetimeIndex
  // Therefore, this function just converts the timestamps to Date objects
  const convertTimestampIdxsToDateObjects = (timestampIdxs: number[]) => {
    return timestampIdxs.map((timestamp) =>
      new Date(timestamp / 1000000).toUTCString()
    ); // Convert ns to ms for JavaScript Date
  };

  return {
    reconstructTimestampsFromRLEByteStream,
    convertTimestampIdxsToDateObjects,
  };
};
